import ReactOnRails from 'react-on-rails'
import { lazy } from 'react'
import '../search_controls'
import { PremiumLabel } from '@lacedltd/laced-components'
import Carousel from '../components/Carousel'
import Hero from '../components/home/Hero'
import WalletPayment from '../components/payments/WalletPayment'
import ProductSaleItem from '../components/ProductSaleItem'
import SellingSearch from '../components/SellingSearch'
import ProductHeader from '../components/product_show/ProductHeader'
import ProductImageViewer from '../components/product_show/ProductImageViewer'
import ProductInfo from '../components/product_show/ProductInfo'
import AuthCentreNotice from '../components/atoms/AuthCentreNotice'
import StockSizeOptions from '../components/StockSizeOptions'
import PasswordForm from '../components/passwords/PasswordForm'
import ResetEmailSent from '../components/passwords/ResetEmailSent'
import PasswordUpdated from '../components/passwords/PasswordUpdated'
import RegistrationForm from '../components/registering/RegistrationForm'
import CheckoutButton from '../components/CheckoutButton'
import NumberBadge from '../components/atoms/NumberBadge'
import {
  CookiesPolicyFr,
  CookiesPolicyEn,
  CookiesPolicyDe
} from '../components/pages/CookiesPolicy'
import Paginator from '../components/atoms/Paginator'
import ChipCarousel from '../components/ChipCarousel'
import PopularNow from '../components/PopularNow/PopularNow'
import ProductHero from '../components/product_show/ProductHero'
import OrderSummary from '../components/Checkout/OrderSummary'
import PhoneNumberInput from '../components/Checkout/PhoneNumberInput'
import PremiumCartFlag from '../components/Cart/PremiumCartFlag'

import '../src/global'
import '../src/monday'
import '../src/lazysizes.min'

ReactOnRails.register(
  /** @type {any} */ ({
    AuthCentreNotice,
    CheckoutButton,
    CookiesPolicyEn,
    CookiesPolicyFr,
    CookiesPolicyDe,
    Hero,
    PasswordForm,
    PasswordUpdated,
    ProductHeader,
    ProductImageViewer,
    ProductInfo,
    ProductSaleItem,
    SellingSearch,
    RegistrationForm,
    ResetEmailSent,
    StockSizeOptions,
    WalletPayment,
    NumberBadge,
    Paginator,
    ChipCarousel,
    PopularNow,
    Carousel,
    BlogProductCards: lazy(() => import('../components/BlogProductCards')),
    GlobalNotificationBanner: lazy(() =>
      import('../components/shared/GlobalNotificationBanner')
    ),
    HolidaySeasonDeliveryGuaranteeBanner: lazy(() =>
      import('../components/shared/HolidaySeasonDeliveryGuaranteeBanner')
    ),
    ProductHero,
    OrderSummary,
    PhoneNumberInput,
    PremiumCartFlag,
    PremiumLabel
  })
)
